import React, {useEffect} from 'react'
import {TextField} from "@fluentui/react";
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import {IProductBundleItem} from "../../models/ProductBundles";

interface IProductBundleQuantityEntryProps {
    item: IProductBundleItem;
    onChange: (qty: number) => void;
}

const ProductBundleQuantityEntry: React.FC<IProductBundleQuantityEntryProps> = (props) => {
    const [tempValue, setTempValue] = React.useState<string | undefined>(props.item.details?.quantity?.toString() ?? "1");
    const [warn, setWarn] = React.useState<boolean>(false);
    const [source, setSource] = React.useState<string | undefined>(props.item.details?.source);

    useEffect(() => {
        if(props.item.details?.source && props.item.details.source !== '') {
            setSource(props.item.details.source);
        }
        else{
            setSource('LowestInStock');
        }
    }, [props.item.details?.source]);

    React.useEffect(() => {
        const stock = calculateStock();
        if (props.item.details?.quantity && stock < props.item.details?.quantity) {
            setWarn(true);
        } else {
            setWarn(false);
        }
    }, [props.item.details?.quantity, source])

    React.useEffect(() => {
        setTempValue(props.item.details?.quantity?.toString() ?? '1');
    }, [props.item.details?.quantity]);

    const handleChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, v: string | undefined) => {
        setTempValue(v);
    }

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (e.currentTarget.value === '') {
            setTempValue('1');
            props.onChange(1);
            return;
        }
        setTempValue(e.currentTarget.value ?? '1');
        const val = parseFloat(e.currentTarget.value ?? '1');
        if (!isNaN(val)) {
            props.onChange(val);
        }  else {
            props.onChange(1);
        }
    }

    const calculateStock = () => {
        let stock = 0;
        if(props.item?.vendors == null) return stock;
        if(source === 'LowestPrice'){ //just lowest price
            let cost = 0;
            props.item?.vendors.forEach(v =>{
                if(cost == 0 || (v.cost && v.cost < cost)){
                    stock = v.inStock ? (v.onHand ?? 99999) : 0;
                    cost = v.cost ?? 0;
                }
            })
        }
        else if(source === 'LowestInStock'){ //lowest price in stock
            let cost = 0;
            props.item?.vendors.forEach(v =>{
                if(v.inStock && (cost == 0 || ((v.cost && v.cost < cost) && v.onHand))){
                    stock = v.inStock ? (v.onHand ?? 99999) : 0;
                    cost = v.cost ?? 0;
                }
            })
        }
        else{ //vendor specific selection
            const vendor = props.item?.vendors.find((v) => v.vendorName === source);
            if (vendor) {
                stock = vendor.inStock ? (vendor.onHand ?? 99999) : 0;
            }
        }
        return stock;
    }

    return (<>
        <TooltipHost
            content="Quantity exeeds stock" 
            hidden={!warn}
        >
            <TextField
                iconProps={warn ? {iconName: 'WarningSolid', style:{color: 'red'}} : undefined} 
                value={tempValue} 
                onChange={handleChange} 
                onBlur={handleBlur}
            />
        </TooltipHost>
    </>);
}

export default ProductBundleQuantityEntry;